import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ComboService } from '../../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { ApprovalMatrixFormFilterComponent } from '../../ApprovalMatrixFormFilter/approval-matrix-form-filter/approval-matrix-form-filter.component';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { SessionService } from '../../../Util/Session/session.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { LeaveService } from '../../../Model/Leave/leave.service';
import { CommonService } from '../../../Model/Common/common.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';

@Component({
  selector: 'app-leave-policies-form',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, NgbTooltip, LoaderComponent],
  templateUrl: './leave-policies-form.component.html',
  styleUrl: './leave-policies-form.component.scss'
})
export class LeavePoliciesFormComponent {
  isDisabled: boolean = false;
  isPageDisabled: boolean = true;
  LastWebESSApplicabilityId = null;
  Leaveeligibility = [{ LeaveeligibilityID: 1, LeaveeligibilityName: 'Normal Days' }, { LeaveeligibilityID: 2, LeaveeligibilityName: 'Weekly Off', }, { LeaveeligibilityID: 3, LeaveeligibilityName: 'Paid Holidays', }, { LeaveeligibilityID: 4, LeaveeligibilityName: 'Leave', }, { LeaveeligibilityID: 5, LeaveeligibilityName: 'Festival Holiday', }]
  user = [] as any;
  LeaveTypes = [] as any;
  LeaveRuleDetail = {
    SelectType: 'insert',
    ESS_LeaveRuleID: 0,
    LeaveRuleName: null,
    //LeaveRuleCode: null,
    LeaveMasterId: null as any,//0,
    LeaveType: null as any,//'Unpaid',
    //Description: null,
    //AfterEffectiveYear: null,
    //AfterEffectiveMonth: null,
    //ESS_ReasonEffectiveAfterID: null,
    // IsAccural: false,
    //LeaveAlloted: null,
    //LeaveAllotedCredit: 'Monthly',
    // DOCAfterEffectiveYear: null,
    // DOCAfterEffectiveMonth: null,
    LeaveAfterEffectiveYear: null,
    LeaveAfterEffectiveMonth: null,
    DOCLeaveAlloted: null as any,
    DOCLeaveAllotedCredit: 'Monthly',
    // DOJAfterEffectiveYear: null,
    // DOJAfterEffectiveMonth: null,
    DOJLeaveAlloted: null as any,
    DOJLeaveAllotedCredit: 'Monthly',
    IsCarryForward: false,
    CarrryForwardLimit: null,
    IsLeaveEncashment: false,
    LeaveEncashmentLimit: null,
    IsGender: null,
    Gender: null as any,// 'All',
    IsMaritialStatus: null,
    MaritialStatus: null as any,//'Unmarried',
    IsAttachment: false,
    AttachmentLimit: null,
    IsWeekendBetweenLeaveCounted: 'D',
    WeekendBetweenLeaveCountDays: null,
    IsHolidayBetweenLeaveCounted: 'D',
    HolidayBetweenLeaveCountDays: null,
    ExceedLeaveBalanceOption: 'Dont allow',
    IsFullDayDurationsAllowed: true,
    IsHalfDayDurationsAllowed: true,
    IsAllowRequestsForPastDates: false,
    PastDateRequestLimit: null,
    IsAllowRequestsForFutureDates: false,
    FutureDateRequestLimit: null,
    IsAllowRequestsForRequestAdvance: false,
    FutureDateRequestAdvance: null,
    IsAdminsOnEmployeeBehalf: false,
    IsMinimumLeavePerApplication: false,
    MinimumLeavePerApplication: null,
    IsMaximumConsecutiveDaysAllowed: false,
    MaximumConsecutiveDaysAllowed: null,
    IsMinimumGapBetweenApplications: false,
    MinimumGapBetweenApplications: null,
    IsFileUploadRequired: false,
    FileUploadLImit: null,
    IsMaximumApplicationsPerYear: false,
    MaximumApplicationsPerYear: null,
    MinimumDaysForLeaveEligibility: null,
    IsNormalDay: false,
    IsWeeklyOff: false,
    IsPaidHoliday: false,
    IsLeave: false,
    IsFestivalHoliday: false,
    LeaveCalculated: 'f',
    ProRatedLeaveCalOn: null as any,//add on 25 march 2026
    ProRatedFixedDays: 0 as any,//add on 25 march 2026
    AllowLeaveForPreviousMonth: false,
    DefaultLeave: false,
    EmpType: 'FRONT',
    WebESSApplicabilityId: null as any,//0,
    IsDualApplicability: false,
    MappedId1: null as any,
    WebESSApplicabilityId1: null as any,
    MappedId: null as any,
    LeaveeligibilityIDs: [1],
    AllowLeaveRequestForConfirmedEmployee: false,
    AllowRequestAfterMonthlock: false,
    //IsClubbingRestricted: false as any,
    //LeaveRuleClubbingRestrictionId: null as any,
    IsSplitAllowed: false as any,
    //IsBirthdaySpecialLeaveAllowence:false as any,//remove on 25 march 2026
    CreditBasedOn: 'salary' as any,//add on 25 march 2026
    AdvanceCreditBasedOn: 'Monthly',//add on 25 march 2026
    CarrryForwardCredit: null as any,//add on 26 march 2026
  }

  Filter = {
    BranchID: null,
    ClientID: null,
    SiteID: null,
  }
  isDualPolicyPossible = 0;
  Applicabilitys = [] as any;
  States = [] as any;
  StatesFilter = [] as any;
  Branchs = [] as any;
  BranchsFilter = [] as any;
  Clients = [] as any;
  ClientsFilter = [] as any;
  Sites = [] as any;
  SitesFilter = [] as any;
  Designations = [] as any;
  DesignationsFilter = [] as any;
  ApplicabilityDatas = [] as any;
  ApplicabilityDatasFilter = [] as any;
  Companys = [] as any;
  CompanysFilter = [] as any;
  Departments = [] as any;
  DepartmentsFilter = [] as any;
  Users = [] as any;
  UsersFilter = [] as any;
  ApprovalSubCategory = [] as any;
  ApprovalSubCategoryFilter = [] as any;
  Grades = [] as any;
  GradesFilter = [] as any;

  ReasonEffectiveAfters = [] as any;
  ChildApplicabilityDatas = [] as any;
  ChildApplicabilityDatasFilter = [] as any;
  EmpServiceTypes = [] as any;
  EmpServiceTypesFilter = [] as any;
  DualApplicabilitys = [] as any;

  constructor(
    private session: SessionService,
    private route: ActivatedRoute,
    private toast: ToastService,
    private combo: ComboService,
    private approvalMatrix: ApprovalMatrixService,
    private modalService: NgbModal,
    private leave: LeaveService,
    private router: Router,
    protected common: CommonService,
    protected tooltip: TooltipService,
    private employeeRegistration: EmployeeRegistrationService,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.LeaveRuleDetail.ESS_LeaveRuleID = parseInt(params['id']));
  }

  ngOnInit(): void {
    this.ComboLoad('ReasonEffectiveAfter');
    if (this.LeaveRuleDetail.ESS_LeaveRuleID > 0) {
      this.ESSLeavePolicySelectGet();
    } else {
      this.GetApplicability();
      this.GetChildApplicability();
    }
    this.LoadEmployeeLeaveCombo();
  }

  ngAfterViewInit() {
    this.isPageDisabled = false;
  }

  Validate(form: any) {
    if (form.valid) {
      this.ESSLeavePolicyInsertUpdate();
    }
    else {
      form.submitted = true;
    }
  }

  ComboLoad(Combotype: String, id = 0) {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype,
      'EmpType': this.LeaveRuleDetail.EmpType,
      'EmpMasterID': id,
      'LeaveMasterId': id
    }).subscribe({
      next: (response) => {
        if (Combotype == 'ReasonEffectiveAfter') {
          this.ReasonEffectiveAfters = response.ComboLoad;
        } else if (Combotype == 'EmpLoadOnId') {
          if (response.ComboLoad.length > 0) {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == response.ComboLoad[0].EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: response.ComboLoad[0].EmpMasterID,
                  ApplicabilityData: response.ComboLoad[0].FullName,
                  WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          }
        }
        else if (Combotype == 'LeaveDetails') {
          if (response.ComboLoad && response.ComboLoad.length > 0) {
            this.LeaveRuleDetail.LeaveType = this.common.ToLowerCase(response.ComboLoad[0].LeaveType) == 'paid' ? 'Paid' : this.common.ToLowerCase(response.ComboLoad[0].LeaveType) == 'unpaid' ? 'Unpaid' : null;
            this.LeaveRuleDetail.Gender = this.common.ToLowerCase(response.ComboLoad[0].Gender) == 'all' ? 'All' : this.common.ToLowerCase(response.ComboLoad[0].Gender) == 'male' ? 'Male' : this.common.ToLowerCase(response.ComboLoad[0].Gender) == 'female' ? 'Female' : this.common.ToLowerCase(response.ComboLoad[0].Gender) == 'other' ? 'Other' : null;
            this.LeaveRuleDetail.MaritialStatus = this.common.ToLowerCase(response.ComboLoad[0].MaritalStatus) == 'all' ? 'All' : this.common.ToLowerCase(response.ComboLoad[0].MaritalStatus) == 'married' ? 'Married' : this.common.ToLowerCase(response.ComboLoad[0].MaritalStatus) == 'unmarried' ? 'Unmarried' : null;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetApplicability(IsClear = true) {
    this.isDisabled = true;
    this.approvalMatrix.GetApplicability({ SelectType: 'SR', WebESSApplicabilityMasterID: 0, EmpType: this.LeaveRuleDetail.EmpType }).subscribe({
      next: (response) => {
        this.Applicabilitys = response.Table;
        if (this.Applicabilitys.filter((e: any) => e.WebESSApplicabilityMasterID == this.LeaveRuleDetail.WebESSApplicabilityId).length == 0) {
          this.LeaveRuleDetail.WebESSApplicabilityId = null;
          this.ApplicabilityDatasFilter = [];
        } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 8 && IsClear) {
          this.ApplicabilityDatasFilter = [];
        }
        this.isDisabled = false;
      },
      complete: () => {
        if (this.LeaveRuleDetail.ESS_LeaveRuleID > 0) {
          this.isDualPolicyPossible = this.Applicabilitys.find((e: any) => e.WebESSApplicabilityMasterID == this.LeaveRuleDetail.WebESSApplicabilityId).IsDualApplicabilityAllowed;
        }
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async ApplicabilityDataFilter(IsFilter = false) {
    this.isDualPolicyPossible = this.Applicabilitys.find((e: any) => e.WebESSApplicabilityMasterID == this.LeaveRuleDetail.WebESSApplicabilityId).IsDualApplicabilityAllowed;

    // if (this.LeaveRuleDetail.WebESSApplicabilityId != 8 || !IsFilter) {
    //   this.ApplicabilityDatas = [];
    //   this.ApplicabilityDatasFilter = [];
    // }
    if (IsFilter || await this.Confirmation(IsFilter)) {
      if (!IsFilter) {
        this.ApplicabilityDatas = [];
        this.ApplicabilityDatasFilter = [];
        this.LeaveRuleDetail.MappedId = null;
        this.LastWebESSApplicabilityId = this.LeaveRuleDetail.WebESSApplicabilityId;
      } else {
        this.ApplicabilityDatas = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck);
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
      }

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
      if (this.LeaveRuleDetail.WebESSApplicabilityId == 1) {
        this.ApprovalComboLoad('Company');
      } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 5) {
        this.ApprovalComboLoad('Department');
      } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 6) {
        this.ApprovalComboLoad('Designation');
      } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 7) {
        this.ApprovalComboLoad('User');
      } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 9) {
        this.ApprovalComboLoad('Grade');
      } else {
        if (this.LeaveRuleDetail.WebESSApplicabilityId != 0) {
          this.FilterForm();
        }
      }
    }
  }

  async Confirmation(IsFilter = false): Promise<boolean> {
    if (!IsFilter && this.LastWebESSApplicabilityId != null) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = this.tooltip.Message.ApplicabiliyChangeMessgae;
      modalRef.componentInstance.Message2 = this.tooltip.Message.ApplicabiliyChangeMessgae2;
      return modalRef.result.then((result) => {
        if (!result) {
          this.LeaveRuleDetail.WebESSApplicabilityId = this.LastWebESSApplicabilityId;
        }
        return result;
      });
    } else {
      return true;
    }
  }

  ButtonApplicabilityDataFilter(id = 0) {
    if (
      (id == 3 || id == 4 || id == 8) ||
      (id == 0 && (this.LeaveRuleDetail.WebESSApplicabilityId == 3 || this.LeaveRuleDetail.WebESSApplicabilityId == 4 || this.LeaveRuleDetail.WebESSApplicabilityId == 8))) {
      this.ApplicabilityDataFilter(true);
    } else {
      this.toast.show({ message: "Filter only allow for client & site", type: toastTypeEnum.warning });
    }
  }

  async childApplicabilityDataFilter() {
    this.LeaveRuleDetail.MappedId1 = ''
    if (this.LeaveRuleDetail.WebESSApplicabilityId1 == 10) {
      this.ESS_AdditionalFillCombo()
    } else if (this.LeaveRuleDetail.WebESSApplicabilityId1 == 9) {
      this.ChildApplicabilityLoad('Grade');
    } else if (this.LeaveRuleDetail.WebESSApplicabilityId1 == 5) {
      this.ChildApplicabilityLoad('Department');
    } else if (this.LeaveRuleDetail.WebESSApplicabilityId1 == 6) {
      this.ChildApplicabilityLoad('Designation');
    }
  }

  ApprovalComboLoad(Combotype: String, Combotype2 = null as any, index = 0) {
    this.isDisabled = true;
    this.combo.ApprovalComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Company') {
          this.Companys = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));
          this.CompanysFilter = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));

          this.Companys.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.CompanyMasterId,
                ApplicabilityData: element.CompanyName,
                WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
                IsCheck: this.LeaveRuleDetail.MappedId != null ? this.LeaveRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.CompanyMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Branch') {
          this.Branchs = response.Table;
          this.BranchsFilter = response.Table;
          debugger
          this.Branchs.forEach((element: any) => {
            console.log(this.LeaveRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID))
            console.log(element.BranchMasterID);
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
                IsCheck: this.LeaveRuleDetail.MappedId != null ? this.LeaveRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Department') {
          this.Departments = response.Table;
          this.DepartmentsFilter = response.Table;

          this.Departments.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DepartmentMasterID,
                ApplicabilityData: element.DepartmentName,
                WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
                IsCheck: this.LeaveRuleDetail.MappedId != null ? this.LeaveRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.DepartmentMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.Table;
          this.DesignationsFilter = response.Table;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DesignationMasterID,
                ApplicabilityData: element.DesignationName,
                WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
                IsCheck: this.LeaveRuleDetail.MappedId != null ? this.LeaveRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.DesignationMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Client') {
          this.Clients = response.Table;
          this.ClientsFilter = response.Table;

          this.Clients.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.ClientGroupMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.ClientGroupMasterID,
                  ApplicabilityData: element.ClientGroupName,
                  WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
                  IsCheck: this.LeaveRuleDetail.MappedId != null ? this.LeaveRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.ClientGroupMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Site') {
          this.Sites = response.Table;
          this.SitesFilter = response.Table;

          this.Sites.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteName,
                  WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
                  IsCheck: this.LeaveRuleDetail.MappedId != null ? this.LeaveRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.SiteMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.ComboLoad;
          this.DesignationsFilter = response.ComboLoad;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
                IsCheck: this.LeaveRuleDetail.MappedId != null ? this.LeaveRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == null) {
          this.Users = response.Table;
          this.UsersFilter = response.Table;

          this.Users.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.UserMasterId,
                ApplicabilityData: element.UserName,
                WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
                IsCheck: this.LeaveRuleDetail.MappedId != null ? this.LeaveRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.UserMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == 'Employee') {
          response.Table.forEach((element: any) => {
            this.ApprovalSubCategory.push(
              {
                ApprovalSubCategoryID: element.UserMasterId,
                ApprovalSubCategory: element.UserName,
              }
            );
          });
          this.ApprovalSubCategoryFilter[index] = this.ApprovalSubCategory;
        } else if (Combotype == 'Grade') {
          this.Grades = response.Table;
          this.GradesFilter = response.Table;

          this.Grades.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.GradeMasterId,
                ApplicabilityData: element.GradeName,
                WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
                IsCheck: this.LeaveRuleDetail.MappedId != null ? this.LeaveRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.GradeMasterId) >= 0 ? true : false : false,
              }
            );
          });
        }
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        this.LeaveRuleDetail.MappedId = null;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  FilterForm() {
    const modalRef = this.modalService.open(ApprovalMatrixFormFilterComponent, { size: 'lg' });
    modalRef.componentInstance.Title = this.LeaveRuleDetail.WebESSApplicabilityId == 3 ? 'Client' : this.LeaveRuleDetail.WebESSApplicabilityId == 4 ? 'Site' : this.LeaveRuleDetail.WebESSApplicabilityId == 8 ? 'Employee' : '';
    modalRef.componentInstance.WebESSApplicabilityId = this.LeaveRuleDetail.WebESSApplicabilityId;
    modalRef.componentInstance.EmpType = this.LeaveRuleDetail.EmpType;
    modalRef.componentInstance.ShowFilter = {
      ShowBranch: (this.LeaveRuleDetail.WebESSApplicabilityId == 3 || this.LeaveRuleDetail.WebESSApplicabilityId == 4 || this.LeaveRuleDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowClient: (this.LeaveRuleDetail.WebESSApplicabilityId == 4 || this.LeaveRuleDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowSite: (this.LeaveRuleDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowSearchEmployee: (this.LeaveRuleDetail.WebESSApplicabilityId == 8 || this.LeaveRuleDetail.WebESSApplicabilityId == 4) ? true : false
    }
    modalRef.result.then(result => {
      this.Filter.BranchID = result.BranchID;
      this.Filter.ClientID = result.ClientID;
      this.Filter.SiteID = result.SiteID;
      if (this.LeaveRuleDetail.WebESSApplicabilityId == 1) {
        //this.ApprovalComboLoad('Company');
      } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 3) {
        this.ApprovalComboLoad('Client');
      } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 4) {
        if (result.length >= 0) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteCode + '-' + element.SiteName,
                  WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
                  IsCheck: true,
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else {
          this.ApprovalComboLoad('Site');
        }
      } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 5) {
        //this.ComboLoad('Department');
      } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 6) {
        //this.ComboLoad('Designation');
      } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 7) {
        //this.ComboLoad('User');
      } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 8) {
        if (result != undefined) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.EmpMasterID,
                  ApplicabilityData: element.FullName,
                  WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        }
      }
    });
  }

  ApplicabilityCheckAll(event: any) {
    this.ApplicabilityDatasFilter.map((e: any) => e.IsCheck = event.target.checked);
  }

  ChildApplicabilityCheckAll(event: any) {
    this.ChildApplicabilityDatasFilter.map((e: any) => e.IsCheck = event.target.checked);
  }

  SearchDropdown(SearchValue: string, Label: string) {
    if (Label == 'Applicability') {
      this.ApplicabilityDatasFilter = this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityData.toLowerCase().includes(SearchValue.toLowerCase()));
    }
  }

  async ESSLeavePolicyInsertUpdate() {
    await this.common.getPageRights();
    this.SearchDropdown('', 'Applicability');
    if (this.LeaveRuleDetail.CreditBasedOn == null || this.LeaveRuleDetail.CreditBasedOn == '') {
      this.toast.show({ message: 'Please select credit based on salry or advance!', type: toastTypeEnum.warning });
    } else if (this.common.parseFloat(this.LeaveRuleDetail.LeaveAfterEffectiveMonth) > 11) {
      this.toast.show({ message: 'Please enter after effective month. maximum 11!', type: toastTypeEnum.warning });
    }
    // else if (this.common.parseFloat(this.LeaveRuleDetail.DOCLeaveAlloted) > 365) {
    //   this.toast.show({ message: 'Please enter date of confirmation year. maximum 365!', type: toastTypeEnum.warning });
    // } 
    // else if (this.common.parseFloat(this.LeaveRuleDetail.DOJLeaveAlloted) > 365) {
    //   this.toast.show({ message: 'Please enter date of joining year. maximum 365!', type: toastTypeEnum.warning });
    // } 
    else if (this.common.parseFloat(this.LeaveRuleDetail.MinimumDaysForLeaveEligibility) > 365) {
      this.toast.show({ message: 'Please enter minimum days for leave eligibility. maximum 365!', type: toastTypeEnum.warning });
    } else if (this.LeaveRuleDetail.LeaveeligibilityIDs == null || this.LeaveRuleDetail.LeaveeligibilityIDs.length == 0) {
      this.toast.show({ message: 'Please select eligibility based on', type: toastTypeEnum.warning });
    } else if (this.LeaveRuleDetail.AllowLeaveForPreviousMonth == null) {
      this.toast.show({ message: 'Please select allow leave for previous month', type: toastTypeEnum.warning });
    } else if (this.LeaveRuleDetail.LeaveCalculated != 'f' && this.LeaveRuleDetail.LeaveCalculated != 'p') {
      this.toast.show({ message: 'Please select leave calculated based on', type: toastTypeEnum.warning });
    } else if (this.LeaveRuleDetail.IsAttachment && this.common.parseFloat(this.LeaveRuleDetail.AttachmentLimit) > 365) {
      this.toast.show({ message: 'Please enter leave attachment days. maximum 365!', type: toastTypeEnum.warning });
    } else if (this.common.parseFloat(this.LeaveRuleDetail.WeekendBetweenLeaveCountDays) > 365) {
      this.toast.show({ message: 'Please enter weekend between leave count days. maximum 365!', type: toastTypeEnum.warning });
    } else if (this.common.parseFloat(this.LeaveRuleDetail.HolidayBetweenLeaveCountDays) > 365) {
      this.toast.show({ message: 'Please enter holiday between leave count days. maximum 365!', type: toastTypeEnum.warning });
    } else if (!this.LeaveRuleDetail.IsFullDayDurationsAllowed && !this.LeaveRuleDetail.IsHalfDayDurationsAllowed) {
      this.toast.show({ message: 'Please select durations allowed', type: toastTypeEnum.warning });
    } else if (this.common.parseFloat(this.LeaveRuleDetail.PastDateRequestLimit) > 365) {
      this.toast.show({ message: 'Please enter past date request limit. maximum 365!', type: toastTypeEnum.warning });
    } else if (this.common.parseFloat(this.LeaveRuleDetail.FutureDateRequestLimit) > 365) {
      this.toast.show({ message: 'Please enter future date request limit. maximum 365!', type: toastTypeEnum.warning });
    } else if (this.common.parseFloat(this.LeaveRuleDetail.FileUploadLImit) > 365) {
      this.toast.show({ message: 'Please enter file upload limit period exceeds. maximum 365!', type: toastTypeEnum.warning });
    } else if (this.common.parseFloat(this.LeaveRuleDetail.FutureDateRequestAdvance) > 365) {
      this.toast.show({ message: 'Please enter future date request advance. maximum 365!', type: toastTypeEnum.warning });
    } else if (this.LeaveRuleDetail.EmpType != 'FRONT' && this.LeaveRuleDetail.EmpType != 'BACK') {
      this.toast.show({ message: 'Please select applicable for', type: toastTypeEnum.warning });
    } else if (this.LeaveRuleDetail.WebESSApplicabilityId == null) {
      this.toast.show({ message: 'Please select applicability', type: toastTypeEnum.warning });
    } else if (this.LeaveRuleDetail.WebESSApplicabilityId > 0 && this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck).length == 0) {
      this.toast.show({ message: 'Please select sub applicability', type: toastTypeEnum.warning });
    } else if (this.LeaveRuleDetail.IsDualApplicability && this.LeaveRuleDetail.WebESSApplicabilityId1 == null) {
      this.toast.show({ message: 'Please select dual applicability or uncheck dual applicability', type: toastTypeEnum.warning });
    } else if (this.LeaveRuleDetail.IsDualApplicability && this.LeaveRuleDetail.WebESSApplicabilityId1 > 0 && this.ChildApplicabilityDatasFilter.filter((e: any) => e.IsCheck).length == 0) {
      this.toast.show({ message: 'Please select dual sub applicability', type: toastTypeEnum.warning });
    }
    // else if (this.LeaveRuleDetail.IsClubbingRestricted && (this.LeaveRuleDetail.LeaveRuleClubbingRestrictionId == null || this.LeaveRuleDetail.LeaveRuleClubbingRestrictionId == "" || this.LeaveRuleDetail.LeaveRuleClubbingRestrictionId.length == 0)) {
    //   this.toast.show({ message: 'Please select restricted leave or clubbing restricted set as no', type: toastTypeEnum.warning });
    // }
    else {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = 'Do you want to save?';
      modalRef.result.then(result => {
        if ((this.common.PageRight.IsAdd && this.LeaveRuleDetail.ESS_LeaveRuleID == 0) || (this.common.PageRight.IsEdit && this.LeaveRuleDetail.ESS_LeaveRuleID > 0)) {
          if (result) {
            this.isDisabled = true;

            if (this.SplitDisable()) {
              this.LeaveRuleDetail.IsSplitAllowed = false;
            }

            if (this.common.ToLowerCase(this.LeaveRuleDetail.CreditBasedOn) == 'salary') {
              this.LeaveRuleDetail.AdvanceCreditBasedOn = 'Monthly';
            }
            this.setDojDocCredit();

            if (this.common.ToLowerCase(this.LeaveRuleDetail.DOCLeaveAllotedCredit) == 'yearly') {
              this.LeaveRuleDetail.DOCLeaveAlloted = 0;
            }

            if (this.LeaveRuleDetail.DOCLeaveAlloted == null || this.LeaveRuleDetail.DOCLeaveAlloted == '') {
              this.LeaveRuleDetail.DOCLeaveAlloted = 0
            }

            if (this.LeaveRuleDetail.DOJLeaveAlloted == null || this.LeaveRuleDetail.DOJLeaveAlloted == '') {
              this.LeaveRuleDetail.DOJLeaveAlloted = 0
            }

            if (this.LeaveRuleDetail.LeaveeligibilityIDs.findIndex((e: any) => e == 1) >= 0) {
              this.LeaveRuleDetail.IsNormalDay = true;
            } else {
              this.LeaveRuleDetail.IsNormalDay = false;
            }

            if (this.LeaveRuleDetail.LeaveeligibilityIDs.findIndex((e: any) => e == 2) >= 0) {
              this.LeaveRuleDetail.IsWeeklyOff = true;
            } else {
              this.LeaveRuleDetail.IsWeeklyOff = false;
            }

            if (this.LeaveRuleDetail.LeaveeligibilityIDs.findIndex((e: any) => e == 3) >= 0) {
              this.LeaveRuleDetail.IsPaidHoliday = true;
            } else {
              this.LeaveRuleDetail.IsPaidHoliday = false;
            }

            if (this.LeaveRuleDetail.LeaveeligibilityIDs.findIndex((e: any) => e == 4) >= 0) {
              this.LeaveRuleDetail.IsLeave = true;
            } else {
              this.LeaveRuleDetail.IsLeave = false;
            }

            if (this.LeaveRuleDetail.LeaveeligibilityIDs.findIndex((e: any) => e == 5) >= 0) {
              this.LeaveRuleDetail.IsFestivalHoliday = true;
            } else {
              this.LeaveRuleDetail.IsFestivalHoliday = false;
            }

            if (this.LeaveRuleDetail.AllowLeaveForPreviousMonth) {
              this.LeaveRuleDetail.IsAllowRequestsForRequestAdvance = false;
              this.LeaveRuleDetail.FutureDateRequestAdvance = null;
            }

            if (this.LeaveRuleDetail.AllowLeaveForPreviousMonth) {
              this.LeaveRuleDetail.IsAllowRequestsForRequestAdvance = false;
              this.LeaveRuleDetail.FutureDateRequestAdvance = null;
            }

            if (this.LeaveRuleDetail.AllowLeaveForPreviousMonth) {
              this.LeaveRuleDetail.IsAllowRequestsForRequestAdvance = false;
              this.LeaveRuleDetail.FutureDateRequestAdvance = null;
            }

            if (this.common.ToLowerCase(this.LeaveRuleDetail.LeaveCalculated) == 'f') {
              this.LeaveRuleDetail.ProRatedLeaveCalOn = null;
              this.LeaveRuleDetail.ProRatedFixedDays = 0;
            }

            // if (this.LeaveRuleDetail.IsClubbingRestricted == null || this.LeaveRuleDetail.IsClubbingRestricted == "") {
            //   this.LeaveRuleDetail.IsClubbingRestricted = false;
            // }

            // if (this.LeaveRuleDetail.IsClubbingRestricted && this.LeaveRuleDetail.LeaveRuleClubbingRestrictionId != null && this.LeaveRuleDetail.LeaveRuleClubbingRestrictionId != "" && this.LeaveRuleDetail.LeaveRuleClubbingRestrictionId.length > 0) {
            //   this.LeaveRuleDetail.LeaveRuleClubbingRestrictionId = this.LeaveRuleDetail.LeaveRuleClubbingRestrictionId.toString();
            // } else {
            //   this.LeaveRuleDetail.LeaveRuleClubbingRestrictionId = null;
            // }

            if (this.LeaveRuleDetail.IsSplitAllowed == null || this.LeaveRuleDetail.IsSplitAllowed == "") {
              this.LeaveRuleDetail.IsSplitAllowed = false;
            }

            if (this.checkExtraleaveTypeDisableFild()) {
              this.LeaveRuleDetail.AllowLeaveForPreviousMonth = false;
              this.LeaveRuleDetail.AllowRequestAfterMonthlock = false;
              this.LeaveRuleDetail.IsAttachment = false;
              this.LeaveRuleDetail.IsWeekendBetweenLeaveCounted = 'D';
              this.LeaveRuleDetail.IsHolidayBetweenLeaveCounted = 'D';
            }

            // if (this.LeaveRuleDetail.IsBirthdaySpecialLeaveAllowence == null || this.LeaveRuleDetail.IsBirthdaySpecialLeaveAllowence == "") {
            //   this.LeaveRuleDetail.IsBirthdaySpecialLeaveAllowence = false;
            // }
            this.LeaveRuleDetail.MappedId = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck && e.WebESSApplicabilityId == this.LeaveRuleDetail.WebESSApplicabilityId).map((e: any) => e.ApplicabilityDataID).toString();

            if (this.LeaveRuleDetail.IsDualApplicability && this.isDualPolicyPossible) {
              this.LeaveRuleDetail.MappedId1 = this.ChildApplicabilityDatasFilter.filter((e: any) => e.IsCheck && e.WebESSApplicabilityId == this.LeaveRuleDetail.WebESSApplicabilityId1).map((e: any) => e.ApplicabilityDataID).toString();
            } else {
              this.LeaveRuleDetail.IsDualApplicability = false;
              this.LeaveRuleDetail.WebESSApplicabilityId1 = 0;
              this.LeaveRuleDetail.MappedId1 = '';
            }

            this.leave.ESSLeavePolicyInsertUpdate(this.LeaveRuleDetail).subscribe({
              next: (response) => {
                console.log(response);
                if (response.Error_Code == "01") {
                  this.close();
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
                } else {
                  this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
                }
                this.isDisabled = false;
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        } else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      });
    }
  }

  ESSLeavePolicySelectGet() {
    this.isDisabled = true;
    this.leave.ESSLeavePolicySelectGet({ SelectType: 1, ESS_LeaveRuleID: this.LeaveRuleDetail.ESS_LeaveRuleID }).subscribe({
      next: (response) => {
        if (response.Table[0].EmpType == null || response.Table[0].EmpType == '') {
          response.Table[0].EmpType = 'FRONT';
        } else {
          response.Table[0].EmpType = response.Table[0].EmpType.toUpperCase();
        }
        this.LeaveRuleDetail = response.Table[0];
        this.LeaveRuleDetail.LeaveeligibilityIDs = [];

        if (this.LeaveRuleDetail.DOCLeaveAllotedCredit == null) {
          this.LeaveRuleDetail.DOCLeaveAllotedCredit = 'Monthly';
        }
        if (this.LeaveRuleDetail.DOJLeaveAllotedCredit == null) {
          this.LeaveRuleDetail.DOJLeaveAllotedCredit = 'Monthly';
        }

        if (this.LeaveRuleDetail.DOCLeaveAllotedCredit == null) {
          this.LeaveRuleDetail.DOCLeaveAllotedCredit = 'Monthly';
        }

        if (this.common.ToLowerCase(this.LeaveRuleDetail.AdvanceCreditBasedOn) == 'monthly') {
          this.LeaveRuleDetail.AdvanceCreditBasedOn = 'Monthly';
        } else if (this.common.ToLowerCase(this.LeaveRuleDetail.AdvanceCreditBasedOn) == 'yearly') {
          this.LeaveRuleDetail.AdvanceCreditBasedOn = 'Yearly';
        }

        if (this.common.ToLowerCase(this.LeaveRuleDetail.DOJLeaveAllotedCredit) == 'monthly') {
          this.LeaveRuleDetail.DOJLeaveAllotedCredit = 'Monthly';
        } else if (this.common.ToLowerCase(this.LeaveRuleDetail.DOJLeaveAllotedCredit) == 'yearly') {
          this.LeaveRuleDetail.DOJLeaveAllotedCredit = 'Yearly';
        }

        if (this.common.ToLowerCase(this.LeaveRuleDetail.DOCLeaveAllotedCredit) == 'monthly') {
          this.LeaveRuleDetail.DOCLeaveAllotedCredit = 'Monthly';
        } else if (this.common.ToLowerCase(this.LeaveRuleDetail.DOCLeaveAllotedCredit) == 'yearly') {
          this.LeaveRuleDetail.DOCLeaveAllotedCredit = 'Yearly';
        }

        if (this.common.ToLowerCase(this.LeaveRuleDetail.CarrryForwardCredit) == 'monthly') {
          this.LeaveRuleDetail.CarrryForwardCredit = 'Monthly';
        } else if (this.common.ToLowerCase(this.LeaveRuleDetail.CarrryForwardCredit) == 'yearly') {
          this.LeaveRuleDetail.CarrryForwardCredit = 'Yearly';
        }

        if (this.LeaveRuleDetail.IsNormalDay) {
          this.LeaveRuleDetail.LeaveeligibilityIDs.push(1);
        }
        if (this.LeaveRuleDetail.IsWeeklyOff) {
          this.LeaveRuleDetail.LeaveeligibilityIDs.push(2);
        }
        if (this.LeaveRuleDetail.IsPaidHoliday) {
          this.LeaveRuleDetail.LeaveeligibilityIDs.push(3);
        }
        if (this.LeaveRuleDetail.IsLeave) {
          this.LeaveRuleDetail.LeaveeligibilityIDs.push(4);
        }
        if (this.LeaveRuleDetail.IsFestivalHoliday) {
          this.LeaveRuleDetail.LeaveeligibilityIDs.push(5);
        }
        this.onSelectChange();
        // this.LeaveRuleDetail.LeaveDeductTypeObj = [];
        // this.LeaveRuleDetail.LeaveDeductType.split(',').forEach((element: any) => {
        //   this.ShiftRuleDetail.LeaveDeductTypeObj.push(parseInt(element));
        // });

        // if (response.Table[0].IsClubbingRestricted && response.Table3 && response.Table3.length > 0) {
        //   this.LeaveRuleDetail.LeaveRuleClubbingRestrictionId = response.Table3.map((e: any) => e.RestrictedLeaveTypeId);
        // }

        // if (this.LeaveRuleDetail.IsClubbingRestricted == null || this.LeaveRuleDetail.IsClubbingRestricted == "") {
        //   this.LeaveRuleDetail.IsClubbingRestricted = false;
        // }

        if (this.LeaveRuleDetail.IsSplitAllowed == null || this.LeaveRuleDetail.IsSplitAllowed == "") {
          this.LeaveRuleDetail.IsSplitAllowed = false;
        }

        if (this.LeaveRuleDetail.ProRatedLeaveCalOn == '') {
          this.LeaveRuleDetail.ProRatedLeaveCalOn = null;
        }

        // if (this.LeaveRuleDetail.IsBirthdaySpecialLeaveAllowence == null || this.LeaveRuleDetail.IsBirthdaySpecialLeaveAllowence == "") {
        //   this.LeaveRuleDetail.IsBirthdaySpecialLeaveAllowence = false;
        // }

        this.LeaveRuleDetail.MappedId = response.Table2.map((e: any) => e.MappedId).toString();

        this.LeaveRuleDetail.SelectType = 'update';
        this.LeaveRuleDetail.WebESSApplicabilityId1 = response.Table3[0]['WebESSApplicabilityId1'];
        this.LastWebESSApplicabilityId = this.LeaveRuleDetail.WebESSApplicabilityId;

        if (this.LeaveRuleDetail.WebESSApplicabilityId == 1) {
          this.ApprovalComboLoad('Company');
        } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 2) {
          this.ApprovalComboLoad('Branch');
        } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 3) {
          //this.ApprovalComboLoad('Client');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 4) {
          //this.ApprovalComboLoad('Site');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 5) {
          this.ApprovalComboLoad('Department');
        } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 6) {
          this.ApprovalComboLoad('Designation');
        } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 7) {
          this.ApprovalComboLoad('User');
        } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 8) {
          // response.Table2.map((e: any) => e.MappedId).forEach((element: any) => {
          //   this.ComboLoad('EmpLoadOnId', element);
          // });
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.LeaveRuleDetail.WebESSApplicabilityId == 9) {
          this.ApprovalComboLoad('Grade');
        }
        if (this.LeaveRuleDetail.WebESSApplicabilityId == 8) {
          this.GetApplicability(false);
        } else {
          this.GetApplicability();
        }
        this.GetChildApplicability();
        if (this.LeaveRuleDetail.IsDualApplicability) {
          this.LeaveRuleDetail.MappedId1 = response.Table4.map((e: any) => e.MappedId).toString();
          if (this.LeaveRuleDetail.WebESSApplicabilityId1 == 10) {
            this.ESS_AdditionalFillCombo();
          } else if (this.LeaveRuleDetail.WebESSApplicabilityId1 == 5) {
            this.ChildApplicabilityLoad('Department');
          } else if (this.LeaveRuleDetail.WebESSApplicabilityId1 == 6) {
            this.ChildApplicabilityLoad('Designation');
          } else if (this.LeaveRuleDetail.WebESSApplicabilityId1 == 9) {
            this.ChildApplicabilityLoad('Grade');
          }
        }

        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  LoadEmployeeLeaveCombo() {
    this.isDisabled = true;
    this.leave.LoadEmployeeLeaveCombo({ EmpMasterID: this.user.UserId, ComboType: 'LeaveMasterPolicy' }).subscribe({
      next: (response) => {
        this.LeaveTypes = response.ComboLoad;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  // onSelectChange() {
  //   this.ComboLoad('LeaveDetails',parseInt(this.LeaveRuleDetail.LeaveMasterId));
  //   console.log('leavetype ', this.LeaveRuleDetail.LeaveMasterId)
  // }
  onSelectChange() {
    this.ComboLoad('LeaveDetails', this.LeaveRuleDetail.LeaveMasterId)
  }
  onSelectionChange(type: string, event: any) {
    if (type == 'LeaveOff') {
      this.LeaveRuleDetail.IsWeekendBetweenLeaveCounted = event.target.value;
      console.log('Selected value:', this.LeaveRuleDetail.IsWeekendBetweenLeaveCounted);
    }
    else if (type == 'HolidayOff') {
      this.LeaveRuleDetail.IsHolidayBetweenLeaveCounted = event.target.value;
      console.log('redew value:', this.LeaveRuleDetail.IsHolidayBetweenLeaveCounted);
    }
  }

  OrderByApplicability() {
    return this.ApplicabilityDatasFilter.sort((a: any, b: any) => a.ApplicabilityData.localeCompare(b.ApplicabilityData));
  }

  SplitDisable(): boolean {
    if (this.LeaveRuleDetail.LeaveMasterId > 0) {
      const index = this.LeaveTypes.findIndex((e: any) => e.LeaveMasterID == this.LeaveRuleDetail.LeaveMasterId && e.IsSplit);
      if (index >= 0) {
        return false;
      }
    }
    return true;
  }

  AdvanceCreditBasedOnDisable(): boolean {
    if (this.common.ToLowerCase(this.LeaveRuleDetail.CreditBasedOn) == 'advance') {
      return false;
    }
    return true;
  }

  setAdvanceCreditBasedOn() {
    if (this.common.ToLowerCase(this.LeaveRuleDetail.CreditBasedOn) == 'salary') {
      this.LeaveRuleDetail.AdvanceCreditBasedOn = 'Monthly';
    } else if (this.common.ToLowerCase(this.LeaveRuleDetail.CreditBasedOn) == 'advance') {
      if (this.common.ToLowerCase(this.LeaveRuleDetail.ProRatedLeaveCalOn) == 'total working days') {
        this.LeaveRuleDetail.ProRatedLeaveCalOn = null;
      }
    }
    this.setDojDocCredit();
  }

  setDojDocCredit() {
    if (this.LeaveRuleDetail.AdvanceCreditBasedOn != null && this.LeaveRuleDetail.AdvanceCreditBasedOn != "") {
      this.LeaveRuleDetail.DOCLeaveAllotedCredit = this.LeaveRuleDetail.AdvanceCreditBasedOn;
      this.LeaveRuleDetail.DOJLeaveAllotedCredit = this.LeaveRuleDetail.AdvanceCreditBasedOn;

      if (this.common.ToLowerCase(this.LeaveRuleDetail.AdvanceCreditBasedOn) == 'yearly') {
        this.LeaveRuleDetail.CarrryForwardCredit = this.LeaveRuleDetail.AdvanceCreditBasedOn;
      }
    }
  }

  ProRatedFixedDaysDisable(): boolean {
    if (this.common.ToLowerCase(this.LeaveRuleDetail.LeaveCalculated) == 'p' && this.common.ToLowerCase(this.LeaveRuleDetail.ProRatedLeaveCalOn) == 'fixed days') {
      return false;
    }
    //  else if (this.common.ToLowerCase(this.LeaveRuleDetail.LeaveCalculated) == 'f') {
    //   return false;
    // }
    return true;
  }

  checkExtraleaveTypeDisableFild(): boolean {
    // if (this.LeaveRuleDetail.LeaveMasterId == null || this.LeaveRuleDetail.LeaveMasterId == 0 || this.LeaveRuleDetail.LeaveMasterId == '') {
    //   return true;
    // } else if (this.LeaveRuleDetail.LeaveMasterId == 4 || this.LeaveRuleDetail.LeaveMasterId == 10 || this.LeaveRuleDetail.LeaveMasterId == 11 || this.LeaveRuleDetail.LeaveMasterId == 12 || this.LeaveRuleDetail.LeaveMasterId == 13) {
    //   return true;
    // }
    // return false;
    return false;
  }


  close() {
    this.router.navigate(['/setting/leavepolicies/']);
  }

  ChildApplicabilityLoad(Combotype: String, Combotype2 = null as any, index = 0) {
    this.ChildApplicabilityDatas = [];
    this.ChildApplicabilityDatasFilter = [];
    this.isDisabled = true;
    this.combo.ApprovalComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'EmpServiceType') {
          // this.Companys = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));
          // this.CompanysFilter = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));

          // this.Companys.forEach((element: any) => {
          //   this.ApplicabilityDatas.push(
          //     {
          //       ApplicabilityDataID: element.CompanyMasterId,
          //       ApplicabilityData: element.CompanyName,
          //       WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId,
          //       IsCheck: this.LeaveRuleDetail.MappedId != null ? this.LeaveRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.CompanyMasterId) >= 0 ? true : false : false,
          //     }
          //   );
          // });
        } else if (Combotype == 'Department') {
          this.Departments = response.Table;
          this.DepartmentsFilter = response.Table;

          this.Departments.forEach((element: any) => {
            this.ChildApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DepartmentMasterID,
                ApplicabilityData: element.DepartmentName,
                WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId1,
                IsCheck: this.LeaveRuleDetail.MappedId1 != null ? this.LeaveRuleDetail.MappedId1.split(',').findIndex((e: any) => e == element.DepartmentMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.Table;
          this.DesignationsFilter = response.Table;

          this.Designations.forEach((element: any) => {
            this.ChildApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DesignationMasterID,
                ApplicabilityData: element.DesignationName,
                WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId1,
                IsCheck: this.LeaveRuleDetail.MappedId1 != null ? this.LeaveRuleDetail.MappedId1.split(',').findIndex((e: any) => e == element.DesignationMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Grade') {
          this.Grades = response.Table;
          this.GradesFilter = response.Table;

          this.Grades.forEach((element: any) => {
            this.ChildApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.GradeMasterId,
                ApplicabilityData: element.GradeName,
                WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId1,
                IsCheck: this.LeaveRuleDetail.MappedId1 != null ? this.LeaveRuleDetail.MappedId1.split(',').findIndex((e: any) => e == element.GradeMasterId) >= 0 ? true : false : false,
              }
            );
          });
        }
        this.ChildApplicabilityDatasFilter = this.ChildApplicabilityDatas;
        this.LeaveRuleDetail.MappedId1 = null;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_AdditionalFillCombo() {
    this.ChildApplicabilityDatas = [];
    this.ChildApplicabilityDatasFilter = [];
    this.isDisabled = true;
    this.employeeRegistration.ESS_AdditionalFillCombo({
      'SelectType': 'EmpServiceType',
      UserId: this.session.GetUserDetails().UserId
    }).subscribe({
      next: (response) => {
        this.EmpServiceTypes = response.Table;
        this.EmpServiceTypesFilter = response.Table;
        this.EmpServiceTypes.forEach((element: any) => {
          this.ChildApplicabilityDatas.push(
            {
              ApplicabilityDataID: element.ESS_EmpServiceTypeId,
              ApplicabilityData: element.EmpServiceTypeName,
              WebESSApplicabilityId: this.LeaveRuleDetail.WebESSApplicabilityId1,
              IsCheck: this.LeaveRuleDetail.MappedId1 != null ? this.LeaveRuleDetail.MappedId1.split(',').findIndex((e: any) => e == element.ESS_EmpServiceTypeId) >= 0 ? true : false : false,
            }
          );
        });
        this.ChildApplicabilityDatasFilter = this.ChildApplicabilityDatas;
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  OrderByChildApplicability() {
    return this.ChildApplicabilityDatasFilter.sort((a: any, b: any) => a.ApplicabilityData.localeCompare(b.ApplicabilityData));
  }

  GetChildApplicability(IsClear = true) {
    this.isDisabled = true;
    this.approvalMatrix.GetApplicability({ SelectType: 'RDA', WebESSApplicabilityMasterID: 0, EmpType: this.LeaveRuleDetail.EmpType }).subscribe({
      next: (response) => {
        this.DualApplicabilitys = response.Table;
        if (this.DualApplicabilitys.filter((e: any) => e.WebESSApplicabilityMasterID == this.LeaveRuleDetail.WebESSApplicabilityId1).length == 0) {
          this.LeaveRuleDetail.WebESSApplicabilityId1 = null;
          this.ChildApplicabilityDatasFilter = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}